export type StatusVariant = 'success' | 'warning' | 'error' | 'neutral';

interface StatusChipProps {
  label: string;
  variant?: StatusVariant;
  className?: string;
}

export function StatusChip({ label, variant = 'neutral', className = '' }: StatusChipProps) {
  const getVariantClasses = () => {
    switch (variant) {
      case 'success':
        return 'bg-primary/5 text-primary border-primary/20';
      case 'warning':
        return 'bg-secondary/5 text-secondary border-secondary/20';
      case 'error':
        return 'bg-error/5 text-error border-error/20';
      case 'neutral':
      default:
        return 'bg-surface-container-high text-on-surface-variant border-outline-variant/20';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-lg text-[9px] font-label font-black uppercase tracking-widest border transition-all ${getVariantClasses()} ${className}`}
    >
      {label}
    </span>
  );
}
